/**
 * TIA Selection Tool - Cart Results Handler
 * ------------------------------------------
 * Reads URL parameters left by the Katalog TIA backend after cart transfer
 * and displays an appropriate banner on the cart page.
 *
 * URL Parameters:
 *   tia_session      - UUID session identifier (presence indicates TIA transfer)
 *   tia_unmatched    - Number of items from TIA that could not be matched in store
 *   tia_draft_order  - Draft order name/reference for unmatched items (e.g. #D1234)
 *   tia_error        - If "1", indicates the transfer failed entirely
 */
(function () {
  'use strict';

  function init() {
    var params = new URLSearchParams(window.location.search);

    var tiaSession = params.get('tia_session');
    var tiaError = params.get('tia_error');
    var tiaUnmatched = params.get('tia_unmatched');
    var tiaDraftOrder = params.get('tia_draft_order');

    // Only proceed if TIA params are present
    if (!tiaSession && !tiaError) {
      return;
    }

    var banner = document.getElementById('tia-results-banner');
    var titleEl = document.getElementById('tia-banner-title');
    var messageEl = document.getElementById('tia-banner-message');

    if (!banner || !titleEl || !messageEl) {
      return;
    }

    // Remove any previously applied variant class
    banner.classList.remove(
      'tia-results-banner--success',
      'tia-results-banner--warning',
      'tia-results-banner--error'
    );

    var unmatchedCount = tiaUnmatched ? parseInt(tiaUnmatched, 10) : 0;

    if (tiaError === '1') {
      // ----- Error state -----
      banner.classList.add('tia-results-banner--error');
      titleEl.textContent = 'Transfer Failed';
      messageEl.innerHTML =
        'We were unable to process your TIA Selection Tool cart. ' +
        'Please try again or <a href="/pages/contact" class="tia-results-banner__draft-link">contact us</a> for assistance.';
    } else if (unmatchedCount > 0) {
      // ----- Partial match / warning state -----
      banner.classList.add('tia-results-banner--warning');

      var itemWord = unmatchedCount === 1 ? 'item' : 'items';
      titleEl.textContent = 'TIA Cart Transferred — Some Items Need Attention';

      var msg =
        'Your TIA Selection Tool cart has been loaded. However, <strong>' +
        unmatchedCount +
        ' ' +
        itemWord +
        '</strong> could not be matched to products in our store.';

      if (tiaDraftOrder) {
        var draftOrderDisplay = tiaDraftOrder;
        // Ensure the # prefix is present for display
        if (draftOrderDisplay.charAt(0) !== '#') {
          draftOrderDisplay = '#' + draftOrderDisplay;
        }
        msg +=
          ' A draft order <strong>' +
          escapeHtml(draftOrderDisplay) +
          '</strong> has been created for the unmatched items. ' +
          'Our team will review and follow up with you.';
      } else {
        msg += ' Please <a href="/pages/contact" class="tia-results-banner__draft-link">contact us</a> for help with the remaining items.';
      }

      messageEl.innerHTML = msg;
    } else {
      // ----- Full success state -----
      banner.classList.add('tia-results-banner--success');
      titleEl.textContent = 'TIA Cart Transferred Successfully';
      messageEl.innerHTML =
        'All items from your TIA Selection Tool have been added to your cart. ' +
        'Please review the quantities and proceed to checkout when ready.';
    }

    // Show the banner
    banner.style.display = 'block';

    // Close button handler
    var closeBtn = banner.querySelector('.tia-results-banner__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        banner.style.display = 'none';
      });
    }

    // Clean TIA params from the URL without reloading the page
    cleanUrl(params);
  }

  /**
   * Remove TIA-specific query parameters from the URL via history.replaceState
   * so the banner does not reappear on page refresh.
   */
  function cleanUrl(params) {
    var tiaKeys = ['tia_session', 'tia_unmatched', 'tia_draft_order', 'tia_error'];

    tiaKeys.forEach(function (key) {
      params.delete(key);
    });

    var newSearch = params.toString();
    var newUrl =
      window.location.pathname +
      (newSearch ? '?' + newSearch : '') +
      window.location.hash;

    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, document.title, newUrl);
    }
  }

  /**
   * Basic HTML entity escaping to prevent XSS from URL parameters.
   */
  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  // Run when the DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
